import smEllipsis from '../../components/sm-ellipsis/sm-ellipsis';
import { isRtl } from '../../lib/document-dir-utils';



export default function ($cmp, { text }) {
  const more = __('sm@_more');

  return `
    <div class="sm-landing-appstore-app-1-editor-notes sm-landing-appstore-app-1-editor-notes--show-more">
      <div class="sm-landing-appstore-app-1-editor-notes__item">
        <div class="sm-landing-appstore-app-1-editor-notes__h">${__('sm@_app_store_editors_notes')}</div>
        <div class="sm-landing-appstore-app-1-editor-notes__text">
    ${$cmp('sm-landing-appstore-app-1-editor-notes__text--short', smEllipsis, {
    text,
    rows: 3,
    pre: true,
    dots: `${new Array(more.length + 3).join(' ')}`,
    after: `<span class="sm-landing-appstore-app-1-editor-notes__text-more${isRtl() ? '-rtl' : ''}">${more}</span>`
  })}
    <div class="sm-landing-appstore-app-1-editor-notes__text--full">${text}</div>
  </div>
      </div>
    </div>
  `;
}



// WEBPACK FOOTER //
// ./src/landing-appstore-app-1/sm-landing-appstore-app-1-editor-notes/sm-landing-appstore-app-1-editor-notes.template.js